<!-- BEGIN::Added.by.HJSeo.2026.07.14. 정기점검 리포트 이메일 수신자 설정(팝업) -->
<!--
  수신자 저장소는 신규 테이블 없이 기존 conf_alrt_user 를 재사용한다.
  - 코드 쌍(sapDataCode/alertCode)을 정기점검 리포트 전용 값(RCPT_CODE)으로 고정 배정.
  - conf_alrt_user 는 (user_id, sstm_id, stat_cd, alrt_cd) 복합키 + 채널 플래그 8개.
    리포트는 "수신 여부" 하나만 필요하므로 is_warn_email 만 사용하고 나머지 7개는 false.
  - AlertNotifier(실제 알림 발송)는 수집 이벤트의 statCd/alrtCd 로만 조회하므로,
    이 전용 코드 행은 실제 알림 발송 파이프라인에 섞이지 않는다.
  - 저장/조회 API 도 기존 범용 엔드포인트(/preference/alert-users)를 그대로 사용.
    status(NORMAL/NOTEXISTED)와 diff → INSERTED/DELETED 규칙은 AlertUser.vue 와 동일.
-->
<template>
  <v-dialog v-model="show" width="460" persistent>
    <v-card>
      <v-card-title class="text-subtitle-1 py-2">{{ $t('insprpt.rcpt.title') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-data-table
          :headers="headers" :items="users" item-key="userId" :loading="loading"
          dense disable-pagination hide-default-footer fixed-header height="360" class="rcpt-table"
        >
          <template v-slot:item.warningEmail="{ item }">
            <v-checkbox v-model="item.warningEmail" dense hide-details class="d-inline-flex ma-0 pa-0"></v-checkbox>
          </template>
          <template v-slot:no-data>
            <div class="grey--text py-4">{{ $t('insprpt.rcpt.empty') }}</div>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="py-2">
        <v-spacer></v-spacer>
        <v-btn x-small color="primary" depressed :loading="saving" @click="save">{{ $t('common.save') }}</v-btn>
        <v-btn x-small color="primary" depressed @click="close">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from '@/api/common/instances';

// 정기점검 리포트 수신자 전용 코드(conf_alrt_user.stat_cd / alrt_cd). 실제 알림 코드와 겹치지 않는 고정값.
const RCPT_CODE = 'CHKLIST';

export default {
  name: 'ChecklistUserConfig',
  props: {
    value: Boolean,
    systemId: String,
  },
  data() {
    return {
      users: [],
      // 로드 시점 스냅샷(userId → warningEmail). 저장 시 변경분만 diff.
      original: {},
      loading: false,
      saving: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    headers() {
      return [
        { text: this.$t('insprpt.rcpt.userid'), value: 'userId', sortable: false },
        { text: this.$t('insprpt.rcpt.receive'), value: 'warningEmail', align: 'center', width: '90px', sortable: false },
      ];
    },
  },
  watch: {
    value(v) {
      if (v) this.load();
    },
  },
  methods: {
    async load() {
      if (!this.systemId) {
        this.users = [];
        return;
      }
      this.loading = true;
      try {
        const params = { systemId: this.systemId, sapDataCode: RCPT_CODE, alertCode: RCPT_CODE };
        const { data } = await api.get('/preference/alert-users', { params });
        this.users = data || [];
        // 변경분 판정을 위한 원본 수신 상태 스냅샷
        this.original = {};
        this.users.forEach(u => {
          this.original[u.userId] = !!u.warningEmail;
        });
      } catch (e) {
        this.users = [];
        this.$snackbar(this.$t('insprpt.rcpt.loadfail'));
      } finally {
        this.loading = false;
      }
    },
    // 변경된 행만 골라 status(INSERTED/DELETED/UPDATED/NOTEXISTED) 부여. AlertUser.vue makeParams 와 동일 규칙.
    // 리포트는 warningEmail 하나만 쓰므로 isAllFalse = !warningEmail.
    buildPayload() {
      const changed = this.users.filter(u => !!u.warningEmail !== this.original[u.userId]);
      return changed.map(u => {
        const isAllFalse = !u.warningEmail;
        let status;
        if (u.status !== 'NOTEXISTED') status = isAllFalse ? 'DELETED' : 'UPDATED';
        else status = isAllFalse ? 'NOTEXISTED' : 'INSERTED';
        return { ...u, status };
      });
    },
    async save() {
      const payload = this.buildPayload();
      if (!payload.length) {
        this.close();
        return;
      }
      this.saving = true;
      try {
        await api.put('/preference/alert-users', JSON.stringify(payload), { headers: { 'Content-Type': 'application/json' } });
        this.$snackbar(this.$t('insprpt.rcpt.saved'));
        this.$emit('saved');
        this.close();
      } catch (e) {
        this.$snackbar(this.$t('insprpt.rcpt.savefail'));
      } finally {
        this.saving = false;
      }
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.rcpt-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto;
}
</style>
<!-- FINISH::Added.by.HJSeo.2026.07.14. -->
